// extracted by mini-css-extract-plugin
module.exports = {"labelWrapper":"Input_labelWrapper__1QMVa","input":"Input_input__1Dl9g","error":"Input_error__2Btxj"};